import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Page.css';

const Contact: React.FC = () => {
  const form = useRef<HTMLFormElement>(null);
  const [isSending, setIsSending] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSending(true);

    // Replace these with your actual EmailJS service ID, template ID, and public key
    // Sign up at https://www.emailjs.com/ to get these details
    const SERVICE_ID = 'service_naaa8hg';
    const TEMPLATE_ID = 'template_gteqb5a';
    const PUBLIC_KEY = 'pko6CpT_8vrrROa8v';

    if (form.current) {
      emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
        .then((result) => {
          console.log(result.text);
          alert('Thank you for your message! We will get back to you soon.');
          setFormData({ name: '', email: '', message: '' });
        }, (error) => {
          console.log(error.text);
          alert('Failed to send message. Please try again later or contact us directly.');
        })
        .finally(() => {
          setIsSending(false);
        });
    }
  };

  return (
    <div className="page">
      <div className="page-hero" style={{ backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/contact.jpg')" }}>
        <h1 className="animate-fade-up">Contact Us</h1>
        <p className="hero-subtitle animate-fade-up delay-100">Get in touch for a free no-obligation consultation today!</p>
      </div>
      <div className="page-content">
        <section className="content-section">
          <div className="contact-container">
            <div className="contact-info animate-fade-up delay-200">
              <h2>Contact Information</h2>
              <div className="info-item">
                <h3>Address</h3>
                <p>1E, 5 Ceres Court<br/>Rosedale, North Shore City<br/>Auckland, 0632</p>
              </div>
              <div className="info-item">
                <h3>Phone</h3>
                <p>09 870 4679</p>
              </div>
              <div className="info-item">
                <h3>Email</h3>
                <p>admin@growbal.co.nz</p>
              </div>
              <div className="info-item">
                <h3>Business Hours</h3>
                <p>Monday to Friday: 9:00 AM - 5:00 PM</p>
              </div>
            </div>
            <div className="contact-form animate-fade-up delay-300">
              <h2>Send us a Message</h2>
              <form ref={form} onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
                <button type="submit" className="submit-btn" disabled={isSending}>
                  {isSending ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
          
          <div className="map-container animate-fade-up delay-400" style={{ marginTop: '60px' }}>
            <h2>Find Us</h2>
            <iframe 
              width="100%" 
              height="450" 
              style={{ border: 0, borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }} 
              src="https://maps.google.com/maps?q=1E,+5+Ceres+Court,+Rosedale,+North+Shore+City,+Auckland,+0632&t=&z=15&ie=UTF8&iwloc=&output=embed" 
              allowFullScreen
              title="Google Maps Location"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;
